import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const CardContext = /*#__PURE__*/createContext({
  compact: false,
  expandable: false,
  expanded: true,
  defaultExpanded: true,
  onToggle: () => {}
});
export const CardContextProvider = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(CardContext.Provider, {
    value: props,
    children: children
  });
};
export const useCardContext = () => {
  const state = useContext(CardContext);
  if (!state) {
    throw new Error('useCardContext must be used within CardContextProvider');
  }
  return state;
};